export const metadataSelector = state => state.board.metadata;



// WEBPACK FOOTER //
// ./src/redux/board/selectors/metadata.js